/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

const ssr = typeof window === 'undefined';

let BreadcrumbsImport;

/** *********************
 * Breadcrumbs
 ********************** */
export const BreadcrumbsLoad = () => import(
  /* webpackChunkName: "breadcrumbs" */
  '@thd-olt-component-react/breadcrumbs')
  .then((module) => {
    const { Breadcrumbs } = module;
    BreadcrumbsImport = (props) => {
      return <Breadcrumbs {...props} />;
    };
  });

export const Breadcrumbs = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/breadcrumbs')).Breadcrumbs
  : (props) => <BreadcrumbsImport {...props} />;

export const BreadcrumbsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/breadcrumbs')).Breadcrumbs
  : {};
